var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustration404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 355,
    height: 260,
    viewBox: "0 0 355 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M82.0777 101.978C125.444 101.256 125.37 38.2057 82.0777 37.5557C38.7856 38.2779 38.7856 101.328 82.0777 101.978Z",
    fill: "#FFAB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0779 86.6667C104.832 86.3056 104.832 53.2278 82.0779 52.8667C59.3237 53.2278 59.3237 86.3056 82.0779 86.6667Z",
    fill: "#FFD666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M180.925 131.806C241.727 132.817 241.653 221.217 180.925 222.228C120.124 221.145 120.124 132.817 180.925 131.806ZM180.925 148.489C142.657 149.139 142.657 204.75 180.925 205.4C219.194 204.75 219.12 149.139 180.925 148.489Z",
    fill: "#004B50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.285 191.822C130.024 185.539 120.346 188.356 116.726 187.778V139.678C116.726 136.428 115.618 135.633 112.589 135.633C108.674 135.85 102.394 134.622 99.956 138.522L59.3235 187.85C57.3288 190.233 57.9937 194.206 57.8459 197.095C57.8459 200.056 58.9541 201.139 61.9831 201.139H102.394V216.811C101.729 222.517 109.117 220.567 112.515 220.856C115.544 220.856 116.652 219.772 116.652 216.811V201.139C126.847 200.345 130.024 204.389 129.285 191.822ZM75.7243 187.778L102.32 155.711V187.778H75.7243ZM304.079 191.822C304.818 185.539 295.066 188.356 291.446 187.778V139.678C291.446 136.428 290.338 135.633 287.309 135.633C283.393 135.85 277.188 134.622 274.676 138.522L234.043 187.85C232.049 190.233 232.64 194.206 232.566 197.095C232.566 200.056 233.674 201.139 236.703 201.139H277.114V216.811C276.449 222.517 283.837 220.567 287.235 220.856C290.264 220.856 291.372 219.772 291.372 216.811V201.139C301.789 200.345 304.818 204.389 304.079 191.822ZM250.592 187.778L277.188 155.711V187.778H250.592Z",
    fill: "url(#paint0_linear_506_132887)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M314.422 85.3668C314.422 81.7557 311.024 78.8668 307.33 79.4446C305.852 76.7724 302.897 75.1112 299.794 75.1835C302.971 59.7279 277.631 59.7279 280.808 75.1835C274.38 74.6057 269.652 81.9724 273.125 87.3168C274.676 89.8446 277.483 91.3612 280.512 91.289H309.103V91.2168C312.132 90.9279 314.422 88.4001 314.422 85.3668ZM77.0542 144.445C77.128 141.411 74.0252 138.811 70.9962 139.389C69.7403 137.078 67.2285 135.706 64.495 135.778C67.3024 122.489 45.4347 122.489 48.242 135.778C42.7751 135.272 38.7118 141.628 41.6669 146.178C42.9967 148.345 45.4347 149.645 48.0204 149.572H72.5477V149.5C75.0595 149.211 77.0542 147.045 77.0542 144.445Z",
    fill: "#00A76F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_506_132887",
    x1: 57.8459,
    y1: 135.612,
    x2: 57.8459,
    y2: 220.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BE49B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007867"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration404);
export default __webpack_public_path__ + "static/media/illustration_404.f0b4fd913b6940518a497fd0b58b953c.svg";
export { ForwardRef as ReactComponent };